// @Conf
// #hasDoc=true

// ##############################################################

// #             GENEROVANÝ KÓD, NEMODIFIKOVAT!!!!              #

// #                  2024-07-18T10:35:20Z                      #

// ##############################################################


export const A4_CB = 'A4_CB';

export const A4_BAR = 'A4_BAR';

export const A3_CB = 'A3_CB';

export const A3_BAR = 'A3_BAR';

export const VF = 'VF';

export const VF_SKLAD = 'VF_SKLAD';

/**
 * Seznam všech hodnot.
 */
export const values = [
    A4_CB,
    A4_BAR,
    A3_CB,
    A3_BAR,
    VF,
    VF_SKLAD
];

/**
 * Mapa enumu na objekt s podrobnostmi o enumu.
 */
const params = {
    [A4_CB]: {caption: ''},
    [A4_BAR]: {caption: ''},
    [A3_CB]: {caption: ''},
    [A3_BAR]: {caption: ''},
    [VF]: {caption: ''},
    [VF_SKLAD]: {caption: ''}
};

/**
 * Načtení popisku enumu.
 * @return popisek enumu
 */
export function getCaption(value) {
    return params[value].caption;
}